import axios from 'axios';
import Uploader from 'vue-media-upload';
import { createApp } from 'vue/dist/vue.esm-bundler';
import './assets/fontawesome/css/all.css';
import './assets/fontawesome/css/fontawesome.css';
import './bootstrap';
import errors from './components/errors.vue';
import issueDetailsForm from './components/issue-details-form.vue';
import multipleFileInput from './components/multiple-file-input.vue';

const app = createApp({
    components: {
        errors,
        multipleFileInput,
        issueDetailsForm,
    }
});

document.addEventListener('DOMContentLoaded', function() {
    for (const element of document.getElementsByClassName("bug-type-input")) {
        element.addEventListener("change", function (e) {
            var supportPeriod = this.getAttribute('data-support-period');
            var issueId = this.getAttribute('data-issue-id');
            axios.post('/support-period/' + supportPeriod + '/view-tickets/' + issueId, {
                type: this.value
            })
            .then(() => {
                alert('Changed successfully')
            })
            .catch(() => {
                alert('An issue occurred, contact support')
            });
        });
    }
}, false);

app.component('Uploader' , Uploader);

app.mount('#app');

